import { Controller, useFormContext } from "react-hook-form";
import { InputText } from "primereact/inputtext";

export const CustomInput = ({
  name,
  type = "text",
  placeholder,
  rules,
}: any) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <InputText
          {...field}
          type={type}
          className="w-full"
          placeholder={placeholder || `Enter ${name.replace("_", " ")}`}
        />
      )}
    />
  );
};
